Drupal.behaviors.shareButton = {
  attach: function (context, settings) {
    once('shareButton', '.js-share-button', context).forEach(function (element) {
      element.addEventListener('click', function (e) {
        e.preventDefault();
        const el = e.currentTarget;
        const title = el.dataset.title.replace('\n', '');
        const text = el.dataset.text ? el.dataset.text.replace('\n', '') : "";
        const url = el.dataset.url === "#" ? window.location.href : window.location.origin + el.dataset.url;
        const shareOptions = { title: title, url: url, text: text ? text : '' };
        if (navigator.share) { navigator.share(shareOptions); } else { navigator.clipboard.writeText(url).then(function () {
          const messages = new Drupal.Message();
          messages.add(Drupal.t('Article URL copied to clipboard'));
        });
        }
      });
    });
  },
};


